import { InterFaceEducation } from '../components/education/InterFaceEducation'

const certificate: InterFaceEducation.Payload = {
    data: [
        {
            title : '빅데이터 분석 전문가 교육과정',
            subtitle : '6개월(수료)'
        },
        {
            title : '인하대학교',
            subtitle : '산업경영공학과 학사졸업'
        }
    ]
}

export default certificate;
